// @owners { team: patients }
import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';
import { isFuzeRxBrand } from '@alto/design-system';

const onboardingBackgroundColorForPartnership = (
  partnershipName: string | null | undefined,
): BACKGROUND_COLORS_VALUES | null | undefined => {
  if (!partnershipName) {
    return null;
  }
  const colors = new Map<string, BACKGROUND_COLORS_VALUES>([
    ['alto', COLORS.BACKGROUND_COLORS.TERTIARY_LIGHTEST],
    ['progyny', COLORS.BACKGROUND_COLORS.PINK_LIGHTEST],
  ]);
  return colors.get(partnershipName);
};

export const onboardingBackgroundColor = (
  partnershipName: string | null | undefined,
  showProgyny: boolean,
  configuredBackgroundColor?: BACKGROUND_COLORS_VALUES | null,
) => {
  if (isFuzeRxBrand()) {
    return COLORS.BACKGROUND_COLORS.GREY_LIGHTER;
  }

  if (configuredBackgroundColor) {
    return configuredBackgroundColor;
  }

  const partnershipColor = onboardingBackgroundColorForPartnership(partnershipName);

  if (showProgyny) {
    return COLORS.BACKGROUND_COLORS.PINK_LIGHTEST;
  } else if (partnershipColor) {
    return partnershipColor;
  } else {
    return COLORS.BACKGROUND_COLORS.TERTIARY_LIGHTEST;
  }
};
